module.exports = __webpack_public_path__ + "img/hot8.57db3ad7.jpg";